var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25523 10.1886L4.1933 7.12663C3.93557 6.8689 3.93557 6.45103 4.1933 6.1933C4.45103 5.93557 4.8689 5.93557 5.12663 6.1933L7.72663 8.7933L10.3266 6.1933C10.5844 5.93557 11.0022 5.93557 11.26 6.1933C11.5177 6.45103 11.5177 6.8689 11.26 7.12663L8.19804 10.1886C7.93769 10.4489 7.51558 10.4489 7.25523 10.1886V10.1886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3108_224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 8,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25523 10.1886L4.1933 7.12663C3.93557 6.8689 3.93557 6.45103 4.1933 6.1933C4.45103 5.93557 4.8689 5.93557 5.12663 6.1933L7.72663 8.7933L10.3266 6.1933C10.5844 5.93557 11.0022 5.93557 11.26 6.1933C11.5177 6.45103 11.5177 6.8689 11.26 7.12663L8.19804 10.1886C7.93769 10.4489 7.51558 10.4489 7.25523 10.1886V10.1886Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3108_224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3f108a1315e1275d980b86c027c6ed36.svg";
export { ForwardRef as ReactComponent };